import React from 'react';
import { Loader2 } from 'lucide-react';
import { LOGO_URL } from '../../constants';
import { inBubbleApp } from '../../utils/appContext';
import AppLoadingScreen from '../AppLoadingScreen';

const AuthLoading: React.FC = React.memo(() => {
  // The phone app signs in for the user; skip straight to the dashboard's loading card.
  if (inBubbleApp) return <AppLoadingScreen />;

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: 'linear-gradient(to bottom right, #f5f8ef, #e8f0d9)' }}>
      <div className="text-center">
        <img src={LOGO_URL} alt="SmartFilterPro" className="h-16 w-auto mx-auto mb-6" />
        <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4" style={{ color: '#b5c989' }} />
        <h2 className="text-xl font-semibold mb-2" style={{ color: '#2f383a' }}>
          Signing you in
        </h2>
        <p className="text-gray-600">
          Please wait while we verify your account
        </p>
      </div>
    </div>
  );
});

AuthLoading.displayName = 'AuthLoading';

export default AuthLoading;
